import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AnimatedSection from '../components/AnimatedSection';

/* ── FAQ data ── */
const faqs = [
  {
    category: 'General',
    color: '#4fc3f7',
    icon: <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
    items: [
      { q: 'What is Saanvi Innovation?', a: 'Saanvi Innovation is a private limited IT company established in February 2021, based in Gwalior, Madhya Pradesh. We specialize in web development, mobile app development, digital marketing, SEO, and software solutions for businesses across India.' },
      { q: 'Where is Saanvi Innovation located?', a: 'Our office is at 21, Near Garg Clinic, Nehru Colony, Mayur Nagar, Thatipur, Gwalior, MP – 474011. Reach us at +91 8770329822 or ceo@saanviinnovation.com.' },
      { q: 'What industries do you serve?', a: 'We serve healthcare, education, real estate, e-commerce, hospitality, NGOs, construction, media, and government sectors. Our diverse portfolio speaks to our versatility.' },
      { q: 'How long have you been in business?', a: 'Saanvi Innovation was incorporated in February 2021. In just a few years we\'ve delivered 200+ projects for 50+ satisfied clients, building a strong reputation across India.' },
    ],
  },
  {
    category: 'Services & Pricing',
    color: '#e8603a',
    icon: <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
    items: [
      { q: 'What services does Saanvi Innovation offer?', a: 'Website Development, UI/UX Design, Digital Marketing, SEO, Social Media Optimization & Marketing, Mobile App Development (Android & iOS), and Custom Software / ERP solutions.' },
      { q: 'How much does a website cost?', a: 'Pricing starts at ₹5,000 for a static website and ₹10,000 for a dynamic CMS website. Prices vary based on complexity and features. We offer transparent pricing with no hidden fees — visit our Pricing page for details.' },
      { q: 'Do you offer custom pricing or packages?', a: 'Yes. Every project is unique. Fill out our quote request form and our team will prepare a customized proposal within 24 hours.' },
      { q: 'Are prices inclusive of GST?', a: 'All quoted prices are exclusive of GST (18%), which will be added to the final invoice as per government regulations.' },
      { q: 'Do you work with startups and small businesses?', a: 'Absolutely. We work with businesses of all sizes — from solo entrepreneurs to established enterprises. Our flexible pricing and scalable solutions make us the ideal partner at every stage.' },
    ],
  },
  {
    category: 'Process & Timeline',
    color: '#10b981',
    icon: <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
    items: [
      { q: 'How long does it take to build a website?', a: 'A static website: 3–5 business days. Dynamic CMS website: 7–15 days. E-commerce or custom software: 4–8 weeks. We always provide a clear timeline before starting work.' },
      { q: 'What is your development process?', a: '5 steps: (1) Requirement Gathering, (2) Design Mockup & Approval, (3) Development & Testing, (4) Review & Revisions, (5) Final Delivery & Launch. You stay involved at every stage.' },
      { q: 'How many revisions are included?', a: 'Unlimited revisions during the design phase. After development begins, we include 2–3 rounds of revisions. Additional revisions are available at a nominal cost.' },
      { q: 'Will I be able to manage my website after delivery?', a: 'Yes. We build websites with user-friendly CMS panels. We also provide a handover session and training so you can update content and manage your website independently.' },
    ],
  },
  {
    category: 'Support & Maintenance',
    color: '#8b5cf6',
    icon: <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>,
    items: [
      { q: 'Do you provide post-launch support?', a: 'Yes. All packages include 30 days of free bug-fixing support after delivery. Extended maintenance plans are available at affordable monthly rates.' },
      { q: 'What if my website goes down or has an issue?', a: 'Contact us at +91 8770329822 or ceo@saanviinnovation.com. Available Mon–Sat, 9 AM–7 PM. For critical issues, we aim to respond within 2–4 hours.' },
      { q: 'Do you provide domain and hosting services?', a: 'Yes. We help with domain registration and web hosting setup. We work with reliable hosting providers and recommend the best plan for your traffic and budget.' },
      { q: 'Can you redesign or improve my existing website?', a: 'Definitely. We regularly take on redesign and performance optimization projects. Share your URL and we\'ll audit it and propose improvements.' },
    ],
  },
  {
    category: 'Payments & Legal',
    color: '#f59e0b',
    icon: <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>,
    items: [
      { q: 'What payment methods do you accept?', a: 'Bank transfer (NEFT/RTGS/IMPS), UPI (Google Pay, PhonePe, Paytm), and cheque payments. Large projects: 50% advance + 50% on delivery.' },
      { q: 'Is my project and business data safe with you?', a: 'Yes. We sign an NDA for all client projects on request. Your data, designs and code remain your property after full payment. We never share client work without written permission.' },
      { q: 'Do you provide any warranty on your work?', a: 'Yes. 30-day warranty covering bugs related to our development work. Does not cover post-delivery change requests or third-party service failures.' },
    ],
  },
];

const FAQ = () => {
  const [openItem, setOpenItem] = useState(null);
  const [activeCategory, setActiveCategory] = useState('All');
  const toggle = (idx) => setOpenItem(openItem === idx ? null : idx);

  const categories = ['All', ...faqs.map(f => f.category)];
  const getCategoryColor = (cat) => faqs.find(f => f.category === cat)?.color || '#e8603a';

  const flatItems = activeCategory === 'All'
    ? faqs.flatMap(f => f.items.map(i => ({ ...i, category: f.category, color: f.color })))
    : (faqs.find(f => f.category === activeCategory)?.items || []).map(i => ({
        ...i,
        category: activeCategory,
        color: getCategoryColor(activeCategory),
      }));

  const totalQ = faqs.reduce((s, f) => s + f.items.length, 0);

  return (
    <div>
      <style>{`
        /* ── Hero ── */
        .faq-hero {
          position: relative;
          background: #07071a;
          padding: 140px 0 90px;
          text-align: center;
          overflow: hidden;
        }

        /* Animated grid background */
        .faq-grid-bg {
          position: absolute; inset: 0;
          background-image:
            linear-gradient(rgba(79,195,247,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(79,195,247,0.04) 1px, transparent 1px);
          background-size: 50px 50px;
          animation: gridScroll 20s linear infinite;
        }
        @keyframes gridScroll {
          from { background-position: 0 0; }
          to   { background-position: 50px 50px; }
        }

        /* Glow orbs */
        .faq-orb-1 {
          position: absolute;
          width: 500px; height: 500px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(232,96,58,0.12) 0%, transparent 65%);
          top: -100px; left: -80px;
          animation: orbFloat1 12s ease-in-out infinite;
          pointer-events: none;
        }
        .faq-orb-2 {
          position: absolute;
          width: 400px; height: 400px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(79,195,247,0.1) 0%, transparent 65%);
          bottom: -80px; right: -60px;
          animation: orbFloat2 15s ease-in-out infinite;
          pointer-events: none;
        }
        .faq-orb-3 {
          position: absolute;
          width: 300px; height: 300px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(139,92,246,0.1) 0%, transparent 65%);
          top: 50%; left: 50%;
          transform: translate(-50%,-50%);
          pointer-events: none;
        }
        @keyframes orbFloat1 {
          0%,100% { transform: translate(0,0); }
          50%     { transform: translate(40px, 30px); }
        }
        @keyframes orbFloat2 {
          0%,100% { transform: translate(0,0); }
          50%     { transform: translate(-30px, -40px); }
        }

        /* Hero badge */
        .faq-hero-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(232,96,58,0.1);
          border: 1px solid rgba(232,96,58,0.3);
          color: #e8603a;
          padding: 8px 20px;
          border-radius: 9999px;
          font-size: 0.75rem; font-weight: 700;
          letter-spacing: 0.1em; text-transform: uppercase;
          margin-bottom: 24px;
          animation: fadeInDown 0.7s ease both;
          position: relative; z-index: 1;
        }
        @keyframes fadeInDown {
          from { opacity:0; transform:translateY(-16px); }
          to   { opacity:1; transform:translateY(0); }
        }

        .faq-hero h1 {
          font-size: clamp(2rem, 5vw, 3.2rem);
          font-weight: 800;
          color: white;
          letter-spacing: -0.04em;
          line-height: 1.12;
          margin-bottom: 18px;
          position: relative; z-index: 1;
          animation: fadeInUp 0.7s ease 0.1s both;
        }
        @keyframes fadeInUp {
          from { opacity:0; transform:translateY(20px); }
          to   { opacity:1; transform:translateY(0); }
        }
        .faq-hero h1 span { color: #e8603a; }
        .faq-hero-sub {
          font-size: 1rem;
          color: rgba(255,255,255,0.5);
          max-width: 520px;
          margin: 0 auto 36px;
          line-height: 1.8;
          position: relative; z-index: 1;
          animation: fadeInUp 0.7s ease 0.2s both;
        }

        /* Hero stats */
        .faq-hero-stats {
          display: flex; justify-content: center; gap: 32px;
          position: relative; z-index: 1;
          animation: fadeInUp 0.7s ease 0.3s both;
          flex-wrap: wrap;
        }
        .faq-hero-stat {
          text-align: center;
        }
        .faq-hero-stat-num {
          font-size: 1.8rem; font-weight: 800;
          color: white; letter-spacing: -0.04em; line-height: 1;
        }
        .faq-hero-stat-num span { color: #e8603a; }
        .faq-hero-stat-lbl {
          font-size: 0.72rem; color: rgba(255,255,255,0.4);
          text-transform: uppercase; letter-spacing: 0.1em;
          font-weight: 600; margin-top: 4px;
        }
        .faq-stat-divider {
          width: 1px; background: rgba(255,255,255,0.1); align-self: stretch;
        }

        /* ── Main content area ── */
        .faq-body {
          background: #f9f9f7;
          padding: 80px 0 96px;
          position: relative;
        }
        .faq-body::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 120px;
          background: linear-gradient(to bottom, #07071a, #f9f9f7);
        }

        /* ── Layout: sidebar + content ── */
        .faq-layout {
          display: grid;
          grid-template-columns: 280px 1fr;
          gap: 32px;
          align-items: start;
          position: relative; z-index: 1;
        }

        /* ── Sidebar categories ── */
        .faq-sidebar {
          position: sticky;
          top: 100px;
        }
        .faq-sidebar-title {
          font-size: 0.7rem; font-weight: 700;
          text-transform: uppercase; letter-spacing: 0.12em;
          color: #9ca3af; margin-bottom: 12px; padding-left: 4px;
        }
        .faq-cat-list { display: flex; flex-direction: column; gap: 4px; }
        .faq-cat-item {
          display: flex; align-items: center; gap: 10px;
          padding: 11px 14px;
          border-radius: 10px;
          cursor: pointer;
          border: 1.5px solid transparent;
          background: white;
          transition: all 0.2s ease;
          font-size: 0.875rem; font-weight: 600;
          color: #374151;
          box-shadow: 0 1px 4px rgba(0,0,0,0.06);
        }
        .faq-cat-item:hover { border-color: #e4e4e0; transform: translateX(2px); }
        .faq-cat-item.active {
          background: #16165a;
          color: white;
          border-color: #16165a;
          box-shadow: 0 4px 16px rgba(22,22,90,0.25);
          transform: translateX(4px);
        }
        .faq-cat-dot {
          width: 8px; height: 8px; border-radius: 50%;
          flex-shrink: 0;
        }
        .faq-cat-count {
          margin-left: auto;
          font-size: 0.7rem; font-weight: 700;
          background: rgba(0,0,0,0.06);
          padding: 2px 8px; border-radius: 50px;
          color: inherit; opacity: 0.7;
        }
        .faq-cat-item.active .faq-cat-count { background: rgba(255,255,255,0.15); opacity:1; }

        /* Search box */
        .faq-search {
          position: relative; margin-bottom: 20px;
        }
        .faq-search input {
          width: 100%; padding: 11px 14px 11px 38px;
          border: 1.5px solid #e4e4e0;
          border-radius: 10px; font-size: 0.875rem;
          background: white; color: #111110;
          outline: none; transition: border-color 0.2s;
          font-family: inherit;
        }
        .faq-search input:focus { border-color: #16165a; box-shadow: 0 0 0 3px rgba(22,22,90,0.08); }
        .faq-search svg {
          position: absolute; left: 12px; top: 50%;
          transform: translateY(-50%); color: #9ca3af;
          pointer-events: none;
        }

        /* ── Accordion ── */
        .faq-list { display: flex; flex-direction: column; gap: 10px; }

        .faq-item {
          background: white;
          border-radius: 14px;
          border: 1.5px solid #e9ecef;
          overflow: hidden;
          transition: all 0.25s ease;
          box-shadow: 0 1px 6px rgba(0,0,0,0.05);
        }
        .faq-item:hover { border-color: #d4d4ce; box-shadow: 0 4px 16px rgba(0,0,0,0.08); }
        .faq-item.open {
          border-color: transparent;
          box-shadow: 0 8px 32px rgba(22,22,90,0.12);
          transform: translateY(-1px);
        }

        .faq-question {
          width: 100%; padding: 20px 22px;
          display: flex; align-items: flex-start; gap: 14px;
          background: none; border: none; cursor: pointer;
          text-align: left; transition: background 0.15s ease;
        }
        .faq-question:hover { background: #f9f9f7; }
        .faq-item.open .faq-question { background: #f9f9f7; }

        /* Number indicator */
        .faq-num {
          width: 28px; height: 28px; border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
          font-size: 0.72rem; font-weight: 800;
          flex-shrink: 0; margin-top: 1px;
          transition: all 0.25s ease;
          background: #f0f0ee; color: #6e6e66;
        }
        .faq-item.open .faq-num { background: #16165a; color: white; }

        .faq-q-content { flex: 1; }
        .faq-cat-chip {
          display: inline-block;
          font-size: 0.62rem; font-weight: 700;
          letter-spacing: 0.08em; text-transform: uppercase;
          padding: 2px 8px; border-radius: 50px;
          margin-bottom: 5px;
        }
        .faq-q-text {
          font-size: 0.95rem; font-weight: 700;
          color: #111110; line-height: 1.4;
          transition: color 0.2s;
        }
        .faq-item.open .faq-q-text { color: #16165a; }

        /* Chevron icon */
        .faq-chevron {
          width: 30px; height: 30px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0; margin-top: 1px;
          background: #f0f0ee; color: #6e6e66;
          transition: all 0.3s cubic-bezier(0.34,1.56,0.64,1);
        }
        .faq-item.open .faq-chevron {
          background: #e8603a; color: white;
          transform: rotate(180deg);
          box-shadow: 0 4px 12px rgba(232,96,58,0.35);
        }

        /* Answer */
        .faq-answer {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.4s cubic-bezier(0.4,0,0.2,1);
          padding: 0 22px 0 64px;
        }
        .faq-answer.open { max-height: 300px; padding-bottom: 22px; }
        .faq-answer p {
          font-size: 0.9rem;
          color: #4a4a44;
          line-height: 1.9;
          margin: 0;
          border-top: 1px solid #f0f0ee;
          padding-top: 14px;
        }

        /* Empty state */
        .faq-empty {
          text-align: center; padding: 60px 20px;
          color: #9ca3af;
        }

        /* ── CTA card ── */
        .faq-cta {
          background: linear-gradient(135deg, #16165a 0%, #07071a 100%);
          border-radius: 20px;
          padding: 56px 48px;
          text-align: center;
          margin-top: 40px;
          position: relative;
          overflow: hidden;
        }
        .faq-cta::before {
          content: '';
          position: absolute; inset: 0;
          background-image: radial-gradient(rgba(255,255,255,0.03) 1px, transparent 1px);
          background-size: 28px 28px;
        }
        .faq-cta::after {
          content: '';
          position: absolute;
          width: 350px; height: 350px; border-radius: 50%;
          background: radial-gradient(circle, rgba(79,195,247,0.08), transparent 60%);
          top: 50%; left: 50%; transform: translate(-50%,-50%);
        }
        .faq-cta h2 {
          font-size: 1.75rem; font-weight: 800; color: white;
          margin-bottom: 10px; position: relative; z-index: 1;
          letter-spacing: -0.03em;
        }
        .faq-cta h2 span { color: #e8603a; }
        .faq-cta p {
          color: rgba(255,255,255,0.55); margin: 0 auto 28px;
          max-width: 480px; line-height: 1.8;
          position: relative; z-index: 1; font-size: 0.9rem;
        }
        .faq-cta-btns {
          display: flex; gap: 12px; justify-content: center;
          flex-wrap: wrap; position: relative; z-index: 1;
        }

        /* ── Responsive ── */
        @media (max-width: 1024px) {
          .faq-layout { grid-template-columns: 1fr; }
          .faq-sidebar { position: static; }
          .faq-cat-list { flex-direction: row; flex-wrap: wrap; }
          .faq-cat-item { flex-shrink: 0; transform: none !important; }
        }
        @media (max-width: 640px) {
          .faq-cta { padding: 36px 24px; }
          .faq-hero-stats { gap: 20px; }
          .faq-stat-divider { display: none; }
        }
      `}</style>

      {/* ── Hero ── */}
      <div className="faq-hero">
        <div className="faq-grid-bg" />
        <div className="faq-orb-1" />
        <div className="faq-orb-2" />
        <div className="faq-orb-3" />

        <div className="container" style={{ position:'relative', zIndex:1 }}>
          <div className="faq-hero-badge">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            Help Center
          </div>

          <h1>Frequently Asked <span>Questions</span></h1>
          <p className="faq-hero-sub">
            Everything you need to know about working with us. Can't find what you're looking for?{' '}
            <a href="mailto:ceo@saanviinnovation.com" style={{ color:'#e8603a', fontWeight:600 }}>Ask us directly</a>.
          </p>

          <div className="faq-hero-stats">
            <div className="faq-hero-stat">
              <div className="faq-hero-stat-num"><span>{totalQ}</span></div>
              <div className="faq-hero-stat-lbl">Questions Answered</div>
            </div>
            <div className="faq-stat-divider" />
            <div className="faq-hero-stat">
              <div className="faq-hero-stat-num"><span>{faqs.length}</span></div>
              <div className="faq-hero-stat-lbl">Categories</div>
            </div>
            <div className="faq-stat-divider" />
            <div className="faq-hero-stat">
              <div className="faq-hero-stat-num"><span>24h</span></div>
              <div className="faq-hero-stat-lbl">Response Time</div>
            </div>
          </div>

          {/* Breadcrumb */}
          <div className="breadcrumb" style={{ marginTop:40 }}>
            <Link to="/">Home</Link><span>›</span><span>FAQ</span>
          </div>
        </div>
      </div>

      {/* ── Main content ── */}
      <div className="faq-body">
        <div className="container" style={{ position:'relative', zIndex:1 }}>
          <div className="faq-layout">

            {/* ── Sidebar ── */}
            <div className="faq-sidebar">
              <div className="faq-sidebar-title">Browse by topic</div>
              <div className="faq-cat-list">
                {categories.map(cat => {
                  const f = faqs.find(x => x.category === cat);
                  const count = cat === 'All' ? totalQ : f?.items.length || 0;
                  const color = cat === 'All' ? '#16165a' : f?.color || '#e8603a';
                  const icon  = cat === 'All'
                    ? <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                    : f?.icon;
                  return (
                    <button
                      key={cat}
                      className={`faq-cat-item ${activeCategory === cat ? 'active' : ''}`}
                      onClick={() => { setActiveCategory(cat); setOpenItem(null); }}
                    >
                      <div className="faq-cat-dot" style={{ background: activeCategory === cat ? 'rgba(255,255,255,0.5)' : color }} />
                      <span style={{ display:'flex', alignItems:'center', gap:7 }}>
                        {icon} {cat}
                      </span>
                      <span className="faq-cat-count">{count}</span>
                    </button>
                  );
                })}
              </div>

              {/* Quick contact card */}
              <div style={{ marginTop:24, background:'linear-gradient(135deg,#16165a,#0d0d2b)', borderRadius:14, padding:'22px 20px', border:'1px solid rgba(255,255,255,0.06)' }}>
                <div style={{ color:'white', fontWeight:700, fontSize:'0.9rem', marginBottom:8 }}>Still need help?</div>
                <p style={{ color:'rgba(255,255,255,0.5)', fontSize:'0.82rem', lineHeight:1.7, margin:'0 0 16px' }}>
                  Our team responds within a few hours.
                </p>
                <a href="https://wa.me/918770329822" target="_blank" rel="noreferrer"
                  style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 14px', background:'#25D366', color:'white', borderRadius:9, fontWeight:700, fontSize:'0.82rem', textDecoration:'none', justifyContent:'center', marginBottom:8, transition:'opacity 0.2s' }}
                  onMouseEnter={e=>e.currentTarget.style.opacity='0.85'}
                  onMouseLeave={e=>e.currentTarget.style.opacity='1'}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  WhatsApp Us
                </a>
                <a href="mailto:ceo@saanviinnovation.com"
                  style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 14px', background:'rgba(255,255,255,0.08)', color:'rgba(255,255,255,0.8)', borderRadius:9, fontWeight:600, fontSize:'0.82rem', textDecoration:'none', justifyContent:'center', border:'1px solid rgba(255,255,255,0.1)', transition:'opacity 0.2s' }}
                  onMouseEnter={e=>e.currentTarget.style.opacity='0.7'}
                  onMouseLeave={e=>e.currentTarget.style.opacity='1'}
                >
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                  Send an Email
                </a>
              </div>
            </div>

            {/* ── Accordion ── */}
            <div>
              {/* Header row */}
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24, flexWrap:'wrap', gap:12 }}>
                <div>
                  <h2 style={{ fontSize:'1.3rem', fontWeight:800, color:'#111110', letterSpacing:'-0.02em', margin:0 }}>
                    {activeCategory === 'All' ? 'All Questions' : activeCategory}
                  </h2>
                  <p style={{ color:'#9ca3af', fontSize:'0.82rem', margin:'4px 0 0' }}>
                    {flatItems.length} question{flatItems.length !== 1 ? 's' : ''}
                  </p>
                </div>
                {activeCategory !== 'All' && (
                  <button onClick={() => { setActiveCategory('All'); setOpenItem(null); }}
                    style={{ padding:'6px 14px', border:'1.5px solid #e4e4e0', background:'white', borderRadius:8, fontSize:'0.8rem', fontWeight:600, color:'#6e6e66', cursor:'pointer', display:'flex', alignItems:'center', gap:6 }}>
                    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                    Clear filter
                  </button>
                )}
              </div>

              {/* Accordion list */}
              <div className="faq-list">
                {flatItems.length === 0 ? (
                  <div className="faq-empty">No questions found.</div>
                ) : (
                  flatItems.map((item, idx) => (
                    <AnimatedSection key={idx} animation="reveal" delay={idx * 30}>
                      <div className={`faq-item ${openItem === idx ? 'open' : ''}`}>
                        <button className="faq-question" onClick={() => toggle(idx)} aria-expanded={openItem === idx}>
                          <div className="faq-num">{idx + 1}</div>
                          <div className="faq-q-content">
                            {activeCategory === 'All' && (
                              <span className="faq-cat-chip" style={{ background:`${item.color}15`, color:item.color, border:`1px solid ${item.color}30` }}>
                                {item.category}
                              </span>
                            )}
                            <div className="faq-q-text">{item.q}</div>
                          </div>
                          <div className="faq-chevron">
                            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
                          </div>
                        </button>
                        <div className={`faq-answer ${openItem === idx ? 'open' : ''}`}>
                          <p>{item.a}</p>
                        </div>
                      </div>
                    </AnimatedSection>
                  ))
                )}
              </div>

              {/* CTA card */}
              <AnimatedSection animation="reveal">
                <div className="faq-cta">
                  <h2>Still Have a <span>Question?</span></h2>
                  <p>Our team is ready to help. Reach out and we'll get back to you within a few hours.</p>
                  <div className="faq-cta-btns">
                    <Link to="/contact#quote" className="btn btn-primary">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" style={{flexShrink:0}}><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                      Ask Us Directly
                    </Link>
                    <a href="tel:+918770329822" className="btn btn-secondary" style={{ display:'inline-flex', alignItems:'center', gap:8, textDecoration:'none' }}>
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" style={{flexShrink:0}}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                      +91 8770329822
                    </a>
                  </div>
                </div>
              </AnimatedSection>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
